export const GET_MASTER_LEADS = "GET_MASTER_LEADS";
export const GET_MASTER_LEADS_ERR = "GET_MASTER_LEADS_ERR";

export const UPLOAD_MASTER_LEAD = "UPLOAD_MASTER_LEAD";
export const UPLOAD_MASTER_LEAD_ERR = "UPLOAD_MASTER_LEAD_ERR";